export function apiRoute () {
  if (location.host.includes('localhost')) {
    return 'http://localhost:3000'
  } else {
    return ''
  }
}

export function retrospectiveRoute () {
  if (location.host.includes('localhost')) {
    return 'http://localhost:3903'
  } else {
    return ''
  }
}

export function projectsRoute () {
  if (location.host.includes('localhost')) {
    return 'http://localhost:3901'
  } else {
    return ''
  }
}

export function projectsApiBase () {
  if (location.host.includes('localhost')) {
    return 'http://localhost:3901/projects'
  } else {
    return '/api/v1/training/images/projects'
  }
}

export function viewerRoute () {
  if (location.host.includes('localhost')) {
    return 'https://admin.test.ratify.global/viewer'
  } else {
    return '/viewer/viewer'
  }
}

export const API_V1 = '/api/v1'
export const AUTH_V1 = '/auth/v1'
export const API_V2 = '/api/v2'
export const AUTH_V2 = '/auth/v2'
